import React, { useEffect } from 'react';
import { Center, Heading, Image, useToast } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import chargerImg from '../../../assets/images/evse_charger_success.svg';
import { SlidingAnimationPageBase } from '../../../common/components/SlidingAnimationPageBase';
import { BoltLoader } from './BoltLoader';
import { selectDeviceSetupState } from './deviceSetupSlice';

/* istanbul ignore next -- @preserve */
export const DeviceJoin = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { isLoaded, status, message } = useSelector(selectDeviceSetupState);
  const toast = useToast();

  useEffect(() => {
    if (!isLoaded) return;

    if (status === 'success') {
      navigate('../setup-success');
    } else {
      navigate('../setup-fail');
    }
  }, [isLoaded, status, message, navigate, toast, t]);

  return (
    <SlidingAnimationPageBase title={t('Common.device setup')} backURL="../device-scan">
      <Center flexDirection="column" px={3} textAlign="center">
        <Image src={chargerImg} alt="Charging Station Setup Successful" ml={7} my={4} />

        <Heading mt={2}>{t('Set Up Hardware.activating charger')}</Heading>
        <BoltLoader />
      </Center>
    </SlidingAnimationPageBase>
  );
};
